import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { LanguageService } from 'src/app/shared/services/language.service';
import { Language } from 'src/app/landing-pages/thi/thi-translations';
import { normalizeThiLang } from 'src/app/landing-pages/thi/thi-lang.util';

@Component({
	selector: 'app-terms-of-service',
	templateUrl: './terms-of-service.component.html',
	styleUrls: ['./terms-of-service.component.scss']
})
export class TermsOfServiceComponent implements OnInit {
	landingLang: Language = 'ar';
	selectedLanguage: any = {
		language: 'Arabic',
		icon: '🇸🇦'
	};

	constructor(
		private translate: TranslateService,
		private languageService: LanguageService,
	) { }

	ngOnInit(): void {
		this.detectCurrentLanguage();
	}

	detectCurrentLanguage(): void {
		const currentLang = this.translate.currentLang || this.translate.defaultLang || 'ar';
		this.landingLang = normalizeThiLang(currentLang);
		switch(currentLang) {
			case 'en':
				this.selectedLanguage = { language: 'English', icon: '🇺🇸' };
				break;
			case 'he':
				this.selectedLanguage = { language: 'Hebrew', icon: '🇮🇱' };
				break;
			case 'ar':
			default:
				this.selectedLanguage = { language: 'Arabic', icon: '🇸🇦' };
				break;
		}
	}

	changeLang(language: string): void {
		this.languageService.apply(language, { refreshRoute: false });
		this.detectCurrentLanguage();
	}
}
